export const orderEventsTitles = {
  ORDER_CREATED: 'Order placed by Customer',
  ORDER_CAPTURED: 'Order captured by Cymbio',
  ORDER_SENT: 'Order sent to the Supplier',
  ORDER_ACCEPTED: 'Order accepted by Supplier',
  ORDER_SENT_OR_ACCEPTED: 'Order sent or accepted by Supplier',
  ORDER_ACCEPTED_WITH_PICK_TICKET: 'Order sent or accepted by Supplier - Pick Ticket: ',
  ORDER_SHIPPED: 'Order shipped by Supplier',
  ORDER_CANCELED: 'Order canceled by Supplier',
  ORDER_AUTO_CANCELED: 'Order canceled due to no stock',
  RETAILER_CANCELED: 'Cancellation made by Sales Channel',
  TRACKING_SENT: 'Tracking sent to Sales Channel',
  ORDER_COMPLETED: 'Order completed',
  FULFILLMENT_RETURN: 'Order returned',
};
